.alfredTools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  padding: 12px;
}

.leftTools {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.toolsWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.researchDropdowns {
  display: flex;
  gap: 4px;
}

.researchDropdownsDivider {
  padding-left: 8px;
  border-left: 1px solid var(--border-soft);
}
